import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import useModel from './useModel';
import useDerivedStateWithModel from './rareHooks/useDerivedStateWithModel';
var useDerivedState = function useDerivedState() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var length = args.length;
  var initState = args[0],
    callback = args[1],
    deps = args[2];
  if (length === 2) {
    callback = args[0];
    deps = args[1];
    initState = callback;
  }
  var _useModel = useModel(initState),
    _useModel2 = _slicedToArray(_useModel, 3),
    clonedModel = _useModel2[1],
    status = _useModel2[2];
  var service = status.service,
    rest = _objectWithoutProperties(status, ["service"]);
  var _useDerivedStateWithM = useDerivedStateWithModel(clonedModel, callback, deps, false, true),
    _useDerivedStateWithM2 = _slicedToArray(_useDerivedStateWithM, 1),
    state = _useDerivedStateWithM2[0];
  return [state, clonedModel, rest];
};
export default useDerivedState;